export default "__VITE_ASSET__BgHBp34l__"